import Mixin from '@ember/object/mixin';

export default Mixin.create({}); // eslint-disable-line ember/no-new-mixins
